import type { ReactNode } from 'react';
import styles from './PageContainer.module.css';

interface PageContainerProps {
  title?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'full';
  children: ReactNode;
}

export default function PageContainer({
  title,
  maxWidth = 'lg',
  children,
}: PageContainerProps) {
  return (
    <div className={`${styles.container} ${styles[maxWidth]}`}>
      {title && <h1 className={styles.title}>{title}</h1>}
      {children}
    </div>
  );
}
